import { SVGProps, Ref, forwardRef } from 'react';

export const FunnelFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M5.955 10.8.5 3.1V1h15v2.1l-5.454 7.7V15H5.955z" fill="currentColor" />
        </g>
    </svg>
));
FunnelFilledSize16Glyph.displayName = 'FunnelFilledSize16Glyph';
